import { API_BASE_URL } from './api';

export interface EmailTemplate {
  id: number;
  template_name: string;
  subject: string;
  subject_ar?: string;
  body_text: string;
  body_text_ar?: string;
  body_html: string;
  body_html_ar?: string;
  variables: string[];
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface CreateTemplateRequest {
  template_name?: string;
  subject: string;
  subject_ar?: string;
  body_text?: string;
  body_text_ar?: string;
  body_html: string;
  body_html_ar?: string;
  variables?: string[];
  is_active?: boolean;
}

export interface UpdateTemplateRequest extends CreateTemplateRequest {
  id: number;
}

export interface TestEmailRequest {
  template_id: number;
  test_email: string;
  language?: 'en' | 'ar';
  test_variables?: Record<string, string>;
}

class EmailTemplateService {
  private getAuthHeaders() {
    const token = localStorage.getItem('admin_token');
    return {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
      'X-Requested-With': 'XMLHttpRequest',
    };
  }

  async getAllTemplates(): Promise<EmailTemplate[]> {
    try {
      const response = await fetch(`${API_BASE_URL}/admin/email-templates`, {
        method: 'GET',
        headers: this.getAuthHeaders(),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      if (!data.success) {
        throw new Error(data.message || 'Failed to fetch templates');
      }

      return data.data;
    } catch (error) {      throw error;
    }
  }

  async getTemplate(id: number): Promise<EmailTemplate> {
    try {
      const response = await fetch(`${API_BASE_URL}/admin/email-templates?id=${id}`, {
        method: 'GET',
        headers: this.getAuthHeaders(),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      if (!data.success) {
        throw new Error(data.message || 'Failed to fetch template');
      }

      return data.data;
    } catch (error) {      throw error;
    }
  }


  async updateTemplate(id: number, templateData: CreateTemplateRequest): Promise<EmailTemplate> {
    try {
      const response = await fetch(`${API_BASE_URL}/admin/email-templates?id=${id}`, {
        method: 'PUT',
        headers: this.getAuthHeaders(),
        body: JSON.stringify(templateData),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      if (!data.success) {
        throw new Error(data.message || 'Failed to update template');
      }

      return data.data;
    } catch (error) {      throw error;
    }
  }


  async testEmail(testData: TestEmailRequest): Promise<void> {
    try {
      const response = await fetch(`${API_BASE_URL}/admin/email-templates/test-send`, {
        method: 'POST',
        headers: this.getAuthHeaders(),
        body: JSON.stringify(testData),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      if (!data.success) {
        throw new Error(data.message || 'Failed to send test email');
      }
    } catch (error) {      throw error;
    }
  }
}

export const emailTemplateService = new EmailTemplateService();